(function (angular) {
    'use strict';
    angular.module('mobilezuz').service('LocalStorage', ['$window',
        function ($window) {
            var self = this;

            angular.extend(self, {
                getItem: getItem,
                setItem: setItem
            });

            function getItem(key) {
                var item = $window.localStorage.getItem(key);
                return item && JSON.parse(item);
            }

            function setItem(key, value) {
                $window.localStorage.setItem(key, value);
            }
        }]);

})(angular);
